import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { default as Config } from '../../config';

export class Link extends Component {
  render() {
    return (<LinkContainer to={{ pathname: Config.baseUrl + this.props.pathname, query: this.props.query }}>{this.props.children}</LinkContainer>)
  }
}


/** WEBPACK FOOTER **
 ** ./js/components/router/link.js
 **/